import { Box } from '@mui/material';
import { SiteHeader } from 'components/HomeRedesign';
import SiteCursor from 'components/HomeRedesign/SiteCursor';
import SiteScrollbar from 'components/HomeRedesign/SiteScrollbar';
import { Suspense, lazy, useEffect } from 'react';
import AOS from 'aos';
import { Outlet, useLocation } from 'react-router';
import Loader from 'components/Loader/Loader';
import { AnchorButton } from 'components/UI';
import CookieBanner from 'components/CookieBanner/CookieBanner';
import classes from './Layout.module.scss';


const SiteFooter = lazy(() => import('components/HomeRedesign/SiteFooter'));
const HomeContacts = lazy(() => import('components/HomeRedesign/HomeContacts'));

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => null;
  }, [ location ]);

  // AOS считает позиции один раз, а страница потом вытягивается (данные, картинки) —
  // блоки «уже на экране» показывались без анимации. Пересчитываем при каждом изменении высоты.
  useEffect(() => {
    if (typeof ResizeObserver === 'undefined') return undefined;

    let timer = 0;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => AOS.refresh(), 100);
    };
    const observer = new ResizeObserver(refresh);
    observer.observe(document.body);
    window.addEventListener('load', refresh);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
      window.removeEventListener('load', refresh);
    };
  }, []);

  // Новая страница — новые элементы: пересобираем список.
  useEffect(() => {
    AOS.refreshHard();
  }, [ location.pathname ]);

  return (
    <Box>
      <SiteHeader />
      <Suspense fallback={<Loader />}>
        <main className={classes.content}>
          <Outlet/>
        </main>
        {/* Карта с контактами — на всех страницах сайта. */}
        <HomeContacts/>
        <SiteFooter/>
      </Suspense>
      <CookieBanner/>
      <AnchorButton/>
      <SiteScrollbar />
      <SiteCursor />
    </Box>
  );
};
export default Layout;
